module.exports = __webpack_public_path__ + "img/new-project2.63edf79c.png";